import React, { useRef } from 'react';
import PropTypes from 'prop-types';

// Components
import Cropper from 'react-cropper';

// Constants
import {
  IMAGE_UPLOADER_PREVIEW,
  IMAGE_PREVIEW,
  IMAGE_SAVE,
  IMAGE_CANCEL,
  IMAGE_ZOOM_IN,
  IMAGE_ZOOM_OUT,
} from '@client/definitions/constants';

// Styles
import 'cropperjs/dist/cropper.css';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './imageCropper.scss';

export const ImageCropper = ({
  previewImage,
  handleReset,
  handleCrop,
  setCurrentView,
}) => {
  const cropperRef = useRef(null);

  const handleSave = () => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    const imgCanvas = cropper?.getCroppedCanvas();

    handleCrop(imgCanvas);
    setCurrentView(IMAGE_UPLOADER_PREVIEW);
  };

  const zoom = (value) => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    cropper?.zoom(value);
  };

  return (
    <>
      <Cropper
        src={previewImage}
        style={{ height: 480, width: '100%' }}
        zoomOnWheel={false}
        aspectRatio={2 / 1}
        guides={false}
        preview=".img-preview"
        viewMode={1}
        movable={false}
        ref={cropperRef}
      />

      <div className={`${styles.btnContainer}`}>
        <button
          className={`${styleHelper.btnPrimaryMd} ${styles.btn}`}
          type="button"
          aria-label={IMAGE_ZOOM_OUT}
          onClick={() => zoom(-0.1)}
        >
          {IMAGE_ZOOM_OUT}
        </button>
        <button
          className={`${styleHelper.btnPrimaryMd} ${styles.btn}`}
          type="button"
          aria-label={IMAGE_ZOOM_IN}
          onClick={() => zoom(0.1)}
        >
          {IMAGE_ZOOM_IN}
        </button>
      </div>

      <div className={styles.imageContainer}>
        <label className={styles.label}>{IMAGE_PREVIEW}</label>
        <div className={`img-preview ${styles.previewImage}`} />
      </div>

      <div className={`${styles.btnContainer}`}>
        <button
          className={`${styleHelper.btnPrimaryMd} ${styles.btn}`}
          type="button"
          aria-label={IMAGE_CANCEL}
          onClick={() => handleReset()}
        >
          {IMAGE_CANCEL}
        </button>

        <button
          className={`${styleHelper.btnPrimaryMd} ${styles.btn}`}
          type="button"
          aria-label={IMAGE_SAVE}
          onClick={handleSave}
        >
          {IMAGE_SAVE}
        </button>
      </div>
    </>
  );
};

ImageCropper.propTypes = {
  previewImage: PropTypes.string.isRequired,
  handleReset: PropTypes.func.isRequired,
  handleCrop: PropTypes.func.isRequired,
  setCurrentView: PropTypes.func.isRequired,
};
